import { AngleLeft } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onClick: () => void
}

export const PrevButton: React.FC<Props> = ({ onClick }) => (
  <button className={css.control_button} onClick={onClick}>
    <AngleLeft />
  </button>
)
